export class LaydownLogSearch { 
    public constructor(init?: Partial<LaydownLogSearch>) {
        Object.assign(this, init);
    }

    storageFacility: string = '';
    rowStart: number = 0;
    rowEnd: number = 199;
    sortColumn: string = 'Id';
    sortOrderDesc: boolean = true;

    filterColumnParams?: { [key: string]: any };
}
